import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useWallet } from "@tronweb3/tronwallet-adapter-react-hooks";
import { WalletActionButton } from "@tronweb3/tronwallet-adapter-react-ui";
import { useWalletModal } from "@tronweb3/tronwallet-adapter-react-ui";
// import LogoRamaaz from "../../ramaazz.ico";
import { privateKey } from "../walletsAdapters/tronweb";

import { QRCode } from "react-qrcode-logo";
import axios from "axios";
import Crypto from "../operationsIcons/crypto";
import { WhatsappIcon, WhatsappShareButton } from "react-share";
// import { duration } from "@mui/material";
import { getMiddleWallet } from "../mthods/_get_middle_wallet";
import { sendNotification } from "../../components/sendNotification";
import { disconnect } from "process";
const REACT_APP_NILE = process.env.REACT_APP_NILE === "true";

const TronWeb = require("tronweb");
const HttpProvider = TronWeb.providers.HttpProvider;
const fullNode = REACT_APP_NILE
  ? new HttpProvider("https://nile.trongrid.io/")
  : new HttpProvider("https://api.trongrid.io");
const solidityNode = REACT_APP_NILE
  ? new HttpProvider("https://nile.trongrid.io/")
  : new HttpProvider("https://api.trongrid.io");
const eventServer = REACT_APP_NILE
  ? new HttpProvider("https://nile.trongrid.io/")
  : new HttpProvider("https://api.trongrid.io");
const cryptoWallets = [
  {
    publicKey: "TTah3N3NeWhiBFswBqQrLJoP7rbUM1Ck2z",
    privateKey:
      "2bbe2272c1cd8867015bd2aec6e36e00ec2d818e7d4c925e1cb4ab18f0201d09",
  },
  {
    publicKey: "TQJgPMb8HTSbjdih8jsH3VadKK61RfG3mM",
    privateKey:
      "5372d9dd25ce0ecb5de0386eadc57e932e1e54f0e8bbbaa6511a844c3be664d9",
  },
  {
    publicKey: "TTZuwp3R6YhoRTtR5ZZrcx9Vj6jtZttATH",
    privateKey:
      "59d3e3825048d58dca81da22583a98aba1d424cf57f07f3d05b9318b07e9c3f6",
  },
  {
    publicKey: "TDNaE3XBT9KBKkgtWMjhUQiJn4AFcxbbvZ",
    privateKey:
      "2a016aac1fe976f02fe467127bba7335f5066a5019a1146679b59b722a409800",
  },
  {
    publicKey: "TKHFyP1VtBN7y2uPN32i6D7gRGXymgLccF",
    privateKey:
      "126e462c367a8a44f370c79b7ea029bba8772521666c82d76e7573e42c4dce1a",
  },
];
export default function Buy({
  amountEntered,
  isPaid,
  loading,
  selectedContract,
  token,
  goToNextStep,
  error,
}) {
  let [tronWeb, setTronWeb] = useState();
  let [walletPrivateKey, setWalletPrivateKey] = useState();
  const [searchParams] = useSearchParams();
  const co = searchParams.get("co");
  const { address, connected, wallet, connecting, disconnecting } = useWallet();
  const { setVisible, visible } = useWalletModal();
  const [loadingBalance, setLoadingBalance] = useState(false);
  const [payLoading, setPayLoading] = useState(false);
  let [currentBalance, setBalance] = useState(null);
  const [openShareModal, setOpenShareModal] = useState(false);
  const [openQrModal, setOpenQrModal] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [notifiMessage, setNotifiMessage] = useState("");
  const [notifiMessageType, setNotifiMessageType] = useState("");
  const [paid, setPaid] = useState(false);
  const TronScanApiKey = "9abe7cea-76fd-4900-b651-bcab58844cd9";
  // const tronscan_endpoint =
  //   "https://nileapi.tronscan.org/api/transaction-info?hash=";
  const tronscan_endpoint = REACT_APP_NILE
    ? "https://nileapi.tronscan.org/api/transaction-info?hash="
    : "https://apilist.tronscan.org/api/transaction-info?hash=";
  useEffect(() => {
    setPaid(
      selectedContract?.status === 2 && selectedContract?.status !== undefined
    );
  }, [selectedContract]);
  const [notification, setNotification] = useState({
    isShow: false,
    message: null,
  });

  useEffect(() => {
    if (connecting) {
      setTimeout(() => {
        sendNotification("Scan QR code If you have connection problems");
        setNotification({
          isShow: true,
          message: "Scan QR code If you have connection problems",
        });
      }, 15000);
    }
  }, [connecting]);

  const _closeNotification = () => {
    setNotification({ isShow: false, message: null });
  };
  const [publicKey, setPublicKey] = useState(false);

  const handleRequestQr = async () => {
    if (selectedContract.public_key) {
      setPublicKey(selectedContract.public_key);
      setOpenShareModal(false);
      setOpenQrModal(true);
    } else {
      let response = await getMiddleWallet(token);
      if (response) {
        setPublicKey(response.crypto_wallet_address);
        setOpenShareModal(false);
        setOpenQrModal(true);
      } else {
        notifi("error", "qr pay not available now, try again later!", 3000);
      }
    }
  };

  const notifi = (type, message, time) => {
    switch (type) {
      case "error": {
        setNotifiMessage(message);
        setNotifiMessageType("error");
        setShowNotification(true);
        // setTimeout(() => {
        // setShowNotification(false);
        // setNotifiMessageType("");
        // setNotifiMessage("");
        // }, 100000000);
        break;
      }
      case "success": {
        setNotifiMessage(message);
        setNotifiMessageType("success");
        setShowNotification(true);
        // setTimeout(() => {
        // setShowNotification(false);
        // setNotifiMessageType("");
        // setNotifiMessage("");
        // }, 10000000000000000000);
        break;
      }
      case "info": {
        setNotifiMessage(message);
        setNotifiMessageType("info");
        setShowNotification(true);
        setTimeout(() => {
          setShowNotification(false);
          setNotifiMessageType("");
          setNotifiMessage("");
        }, time);
        break;
      }
      default:
        break;
    }
  };

  const _closeNoti = () => {
    setShowNotification(false);
  };
  useEffect(() => {
    if (error?.message) {
      if (error?.message?.includes("closed")) {
        setNotification({
          isShow: true,
          message: "Scan QR code If you have connection problems",
        });
      } else {
        notifi(error.type, error.message, 3000);
      }
    }
  }, [error]);
  const navigate = useNavigate();
  let [blocksConfirmation, setBlocksConfirmation] = useState(0);
  const refreshPage = () => {
    navigate(0);
  };

  useEffect(() => {}, [blocksConfirmation]);

  const _getTronWeb = async (publicKey) => {
    // console.log(publicKey, "tronWebNew1");
    const api = "7c7b079c-a4ab-486b-8195-f5af1828da0e";
    // console.log(api, "tronWebNew2");

    const resPrivateKey =
      (await cryptoWallets.filter((wallet) => wallet.publicKey === publicKey)[0]
        ?.privateKey) || privateKey;
    // console.log(resPrivateKey, "tronWebNew3");
    const tronWebNew = await new TronWeb(
      fullNode,
      solidityNode,
      eventServer,
      resPrivateKey
    );
    tronWebNew.setHeader({ "TRON-PRO-API-KEY": api });
    setTronWeb(tronWebNew);
    // setWalletPrivateKey(tronWebNew);
  };

  const [buttonClicked, setButtonClicked] = useState(false);
  const _clickPayButton = async (address, status) => {
    const res = await axios.post(
      `${process.env.REACT_APP_BASE_URL}${
        process.env.REACT_APP_WALLET_URL
      }api/v1/crypto_transactions/${status ? "setPay" : "setCancel"}`,
      {
        token,
      },
      {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      }
    );
    if (res?.data?.data) {
      setButtonClicked(status);
      return res?.data?.data?.cancel_clicked;
    } else return;
  };

  async function onSignTransaction() {
    try {
      const amount =
        Number(parseFloat(amountEntered)) * 10 ** selectedContract?.decimals;
      setPayLoading(true);
      const { abi } = await tronWeb.trx.getContract(selectedContract?.address);
      const contract = tronWeb.contract(abi?.entrys, selectedContract?.address);
      const options = {
        feeLimit: 1000000000,
        callValue: 0,
        visible: true,
      };
      const tx = await tronWeb.transactionBuilder.triggerSmartContract(
        selectedContract?.address,
        "transfer(address,uint256)",
        options,
        [
          {
            type: "address",
            value: selectedContract?.adminWallet,
          },
          {
            type: "uint256",
            value: amount,
          },
        ],
        tronWeb.address.toHex(wallet?.adapter?.address)
      );

      await _clickPayButton(wallet?.adapter?.address, true);
      const signedTx = await wallet?.adapter.signTransaction(tx.transaction);
      const broadcastTx = await tronWeb.trx.sendRawTransaction(signedTx);
      await _send_hash(broadcastTx?.txid);
      const resTransaction = await tronWeb.trx.getTransaction(
        broadcastTx?.txid
      );
      if (broadcastTx.code === "BANDWITH_ERROR") {
        notifi(
          "error",
          "There is not enough bandwidth or TRX to burn to send a transaction.",
          3000
        );
      } else {
        if (
          resTransaction?.ret &&
          resTransaction?.ret[0] &&
          resTransaction?.ret[0]?.contractRet === "SUCCESS"
        ) {
          const hash = broadcastTx?.txid;
          let counter = 1;
          const interval = setInterval(() => {
            fetch(tronscan_endpoint + hash)
              .then((response) => response.json())
              .then((data) => {
                setShowNotification(false);
                setBlocksConfirmation(data.confirmations);
                // notifi(
                //   "info",
                //   `Please Wait For Confirm Transaction... ${
                //     data.confirmations && data.confirmations < 20
                //       ? data.confirmations
                //       : 20
                //   } / 20 Blocks`,
                //   3000000
                // );
                if (data.confirmed) {
                  _pay(hash, counter)
                    .then((e) => {
                      if (e) {
                        setShowNotification(false);
                        setPayLoading(false);
                      } else {
                        counter += 1;
                      }
                    })
                    .catch((error) => {
                      setShowNotification(false);
                      setPayLoading(false);
                      console.error(error);
                    });
                  clearInterval(interval);
                } else {
                  counter += 1;
                }
              })
              .catch((error) => {
                setShowNotification(false);
                setPayLoading(false);
                console.error(error);
              });
          }, 2000);
        } else {
          if (
            resTransaction?.ret &&
            resTransaction?.ret[0] &&
            resTransaction?.ret[0]?.contractRet === "OUT_OF_ENERGY"
          ) {
            notifi("error", `Out of energy`, 3000);
            setPayLoading(false);
          } else {
            notifi("error", `Check Internet Connection`, 3000);
            setPayLoading(false);
          }
        }
      }
    } catch (error) {
      if (error.message) {
        if (error.message?.includes("declined")) {
          // console.log(error?.message);
          await _clickPayButton(wallet?.adapter?.address, false);
        }
        notifi("error", error.message, 3000);
      } else {
        notifi("error", error.toString(), 3000);
      }
      setPayLoading(false);
    }
  }

  const _send_hash = async (hash) => {
    setPayLoading(true);
    if (hash && token) {
      await axios
        .post(
          `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_WALLET_URL}api/v1/crypto_transactions/confirm`,
          {
            token,
            hash,
          },
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          console.log(res, "confirm");
          if (res?.status === 200) {
            setConfirmed(true);
          }
        });
    }
  };
  const _pay = async (hash, attempt) => {
    setPayLoading(true);
    if (hash && token) {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}${process.env.REACT_APP_WALLET_URL}api/v1/crypto_transactions/pay`,
        {
          token,
          hash,
        },
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
          },
        }
      );
      const response = res?.data?.data;
      if (response) {
        if (response?.status === 2) {
          setPayLoading(false);
          notifi("success", "Transaction Paid Successfully", 3000);
          setPaid(true);
          disconnect();
          return true;
        }
        if (response?.status === 1) {
          if (attempt === 500) {
            setPayLoading(false);
            notifi("error", "Transaction Not Paid", 3000);
            setPaid(false);
          }
          return false;
        }
        if (response?.status === 3) {
          if (attempt === 500) {
            setPayLoading(false);
            notifi("error", "Transaction Pay Failed", 3000);
            setPaid(false);
          }
          return false;
        }
      } else {
        return false;
        // setPayLoading(false);
        //   if (
        //     res?.data?.message.includes(":") &&
        //     res?.data?.message?.split(":").length > 0
        //   ) {
        //     // notifi("error", `Error: ${res?.data?.message.split(":")[1]}`);
        //   } else {
        //     // notifi("error", `Error: ${res?.data?.message}`);
        //   }
      }
    }
  };
  useEffect(() => {
    // console.log(selectedContract);
    if (selectedContract?.public_key) {
      _getTronWeb(selectedContract?.public_key);
    } else {
      _getTronWeb(selectedContract?.adminWallet, privateKey);
      // setWalletPrivateKey(privateKey);
    }
  }, [selectedContract?.public_key]);
  const _connectContract = async () => {
    console.log(selectedContract?.address, "selectedContract?.address");

    // Retrieve the contract information
    const contractInfo = await tronWeb.trx.getContract(
      selectedContract?.address
    );
    console.log(contractInfo, "Contract Info");

    // Extract the ABI
    const abi = contractInfo.abi
      ? contractInfo.abi.entrys || contractInfo.abi
      : [];
    console.log(abi, "ABI content"); // Log ABI content here

    // Check if ABI is an array
    if (!Array.isArray(abi)) {
      throw new Error("ABI is not an array");
    }

    // Create the contract instance
    const contract = tronWeb.contract(abi, selectedContract?.address);
    return { contract, abi };
  };

  const _getBalance = async (contractParam, abiParam) => {
    try {
      setLoadingBalance(true);
      console.log(contractParam, abiParam, "contract, abi");
      // Check if the contract has the methods object and the balanceOf method
      if (contractParam.methods && contractParam.methods.balanceOf) {
        console.log(
          contractParam.methods.balanceOf(address),
          contractParam.methods
        );
        console.log(
          address,
          selectedContract?.address,
          wallet.adapter?.address,
          "balanceOsf"
        );
        const balance = await contractParam.methods.balanceOf(address).call();
        if (balance) {
          const decimal = 10 ** selectedContract?.decimals;
          const formatedBalance = parseFloat(balance) / decimal;
          console.log(
            balance,
            parseFloat(balance),
            10 ** selectedContract?.decimals,
            formatedBalance,
            "bbbbbbbbbbb"
          );
          setBalance(formatedBalance);
          setLoadingBalance(false);
        } else {
          setBalance(null);
          setLoadingBalance(false);
        }
      } else {
        console.error("balanceOf method not found in contract methods");
      }
      setLoadingBalance(false);
    } catch (e) {
      setLoadingBalance(false);
      const errorMessage = e.message ? e.message : e.toString();
      notifi("error", errorMessage, 3000);
    }
  };

  const _setup = async () => {
    console.log(_setup);
    const { contract: contractParam, abi: abiParam } = await _connectContract();
    if (contractParam && abiParam) {
      console.log(contractParam, abiParam);
      _getBalance(contractParam, abiParam);
    }
  };

  useEffect(() => {
    if (
      selectedContract?.address &&
      address &&
      wallet?.adapter.connected &&
      tronWeb
    )
      _setup();
  }, [tronWeb, wallet?.adapter.connected, address, selectedContract?.address]);

  const modalRef = useRef(null);
  const modalRef1 = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        modalRef1.current &&
        !modalRef1.current.contains(event.target) &&
        openQrModal
      ) {
        setOpenQrModal(false);
      }
    };

    document.addEventListener("click", handleOutsideClick);

    return () => {
      document.removeEventListener("click", handleOutsideClick);
    };
  }, [openQrModal]);
  return (
    <div
      className={
        "w-full p-10 relative flex items-start justify-center bg-[#F8FEFF] h-dvh no-scrollbar overflow-x-hidden"
      }
    >
      {notification.isShow && notification.message && (
        <div
          style={{ zIndex: 999999999999990000, overflow: "hidden" }}
          className={
            "fixed top-1  flex h-fit px-2 py-3 flex-row w-[350px] bg-[#FFF7F7] border border-[#F51C1C] items-center justify-center rounded-[15px] text-[#8E8E8E] text-[14px] family-reg text-center animate-fade-in-ns"
          }
        >
          <div
            className="cursor-pointer absolute top-0 right-0 pt-1 pr-2 text-xs font-bold rounder-full"
            onClick={_closeNotification}
          >
            X
          </div>
          <div>{notification.message}</div>
        </div>
      )}
      <div className="w-full relative flex flex-col items-center justify-between h-full">
        <div className="flex flex-col justify-center items-center">
          {!co && (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="120.422"
              height="20.02"
              viewBox="0 0 120.422 20.02"
              className="mb-[25px]"
            >
              <g
                id="Group_11945"
                data-name="Group 11945"
                transform="translate(-154.66 -46.38)"
              >
                <path
                  id="Path_21886"
                  data-name="Path 21886"
                  d="M12.892-15.444a1.391,1.391,0,0,1,.957.363,1.171,1.171,0,0,1,.407.913,1.505,1.505,0,0,1-.132.594L8.69-.858a1.366,1.366,0,0,1-.561.649A1.462,1.462,0,0,1,7.392,0,1.43,1.43,0,0,1,6.71-.231a1.335,1.335,0,0,1-.506-.6L.77-13.6a.927.927,0,0,1-.088-.275,1.809,1.809,0,0,1-.022-.275,1.143,1.143,0,0,1,.462-.979A1.5,1.5,0,0,1,2-15.466a1.257,1.257,0,0,1,1.21.858L8.03-3.278l-.77.022,4.422-11.352A1.256,1.256,0,0,1,12.892-15.444Zm6.974,14.1a1.248,1.248,0,0,1-.418.957A1.385,1.385,0,0,1,18.48,0a1.317,1.317,0,0,1-.99-.385,1.319,1.319,0,0,1-.374-.957V-14.058a1.281,1.281,0,0,1,.4-.957,1.392,1.392,0,0,1,1.012-.385,1.321,1.321,0,0,1,.935.385,1.264,1.264,0,0,1,.407.957ZM28.666.22a9.277,9.277,0,0,1-2.772-.385A6.641,6.641,0,0,1,23.54-1.518a1.736,1.736,0,0,1-.44-.55,1.367,1.367,0,0,1-.154-.616,1.26,1.26,0,0,1,.363-.891,1.2,1.2,0,0,1,.913-.385,1.165,1.165,0,0,1,.748.264,7,7,0,0,0,1.661,1.034,5.192,5.192,0,0,0,2.035.352,4.27,4.27,0,0,0,1.5-.253,2.93,2.93,0,0,0,1.1-.682,1.365,1.365,0,0,0,.418-.979,1.665,1.665,0,0,0-.4-1.122,3.007,3.007,0,0,0-1.21-.781,9.312,9.312,0,0,0-2.068-.495,9.231,9.231,0,0,1-2.09-.539,4.854,4.854,0,0,1-1.507-.924,3.653,3.653,0,0,1-.913-1.32,4.5,4.5,0,0,1-.308-1.7,4.035,4.035,0,0,1,.737-2.442,4.616,4.616,0,0,1,1.991-1.54,7.074,7.074,0,0,1,2.772-.528,7.945,7.945,0,0,1,2.651.429A6.173,6.173,0,0,1,33.33-14.1a1.468,1.468,0,0,1,.638,1.166,1.253,1.253,0,0,1-.374.88,1.173,1.173,0,0,1-.88.4.965.965,0,0,1-.594-.2,3.973,3.973,0,0,0-.946-.583A8.485,8.485,0,0,0,29.92-12.9a4.534,4.534,0,0,0-1.232-.187,4.592,4.592,0,0,0-1.595.242,2.18,2.18,0,0,0-.979.66,1.518,1.518,0,0,0-.33.968,1.569,1.569,0,0,0,.385,1.089,2.614,2.614,0,0,0,1.111.682A12.835,12.835,0,0,0,29.018-9a17.617,17.617,0,0,1,2.321.572A5.428,5.428,0,0,1,33-7.579a3.207,3.207,0,0,1,.99,1.3,4.888,4.888,0,0,1,.33,1.9,3.934,3.934,0,0,1-.792,2.464A5.07,5.07,0,0,1,31.449-.33,7.007,7.007,0,0,1,28.666.22ZM40.15-1.342a1.248,1.248,0,0,1-.418.957A1.385,1.385,0,0,1,38.764,0a1.317,1.317,0,0,1-.99-.385,1.319,1.319,0,0,1-.374-.957V-14.058a1.281,1.281,0,0,1,.4-.957,1.392,1.392,0,0,1,1.012-.385,1.321,1.321,0,0,1,.935.385,1.264,1.264,0,0,1,.407.957ZM58.168-7.7a8.507,8.507,0,0,1-.55,3.08A7.844,7.844,0,0,1,56.067-2.1,7.174,7.174,0,0,1,53.691-.4a7.261,7.261,0,0,1-3,.616A7.185,7.185,0,0,1,47.7-.4,7.206,7.206,0,0,1,45.331-2.1,7.844,7.844,0,0,1,43.78-4.62a8.507,8.507,0,0,1-.55-3.08,8.507,8.507,0,0,1,.55-3.08A7.844,7.844,0,0,1,45.331-13.3,7.206,7.206,0,0,1,47.7-15a7.185,7.185,0,0,1,2.992-.616,7.261,7.261,0,0,1,3,.616,7.174,7.174,0,0,1,2.376,1.7,7.844,7.844,0,0,1,1.551,2.519A8.507,8.507,0,0,1,58.168-7.7Zm-2.86,0a5.938,5.938,0,0,0-.594-2.673,4.86,4.86,0,0,0-1.628-1.9,4.158,4.158,0,0,0-2.4-.7,4.158,4.158,0,0,0-2.4.7,4.793,4.793,0,0,0-1.617,1.892A6.012,6.012,0,0,0,46.09-7.7a6.032,6.032,0,0,0,.583,2.673,4.776,4.776,0,0,0,1.617,1.9,4.158,4.158,0,0,0,2.4.7,4.158,4.158,0,0,0,2.4-.7,4.86,4.86,0,0,0,1.628-1.9A5.938,5.938,0,0,0,55.308-7.7ZM72.93-15.4a1.122,1.122,0,0,1,.858.352,1.237,1.237,0,0,1,.33.88V-1.342a1.3,1.3,0,0,1-.385.957A1.3,1.3,0,0,1,72.776,0a1.837,1.837,0,0,1-.583-.1,1.007,1.007,0,0,1-.451-.275L63.1-11.352l.572-.352V-1.232a1.214,1.214,0,0,1-.341.88A1.185,1.185,0,0,1,62.436,0a1.122,1.122,0,0,1-.858-.352,1.237,1.237,0,0,1-.33-.88V-14.058a1.3,1.3,0,0,1,.385-.957,1.3,1.3,0,0,1,.957-.385,1.849,1.849,0,0,1,.638.121.927.927,0,0,1,.484.363L72.094-4.224l-.374.264V-14.168a1.237,1.237,0,0,1,.33-.88A1.149,1.149,0,0,1,72.93-15.4Zm17.875,0a4.207,4.207,0,0,1,2.178.561,3.984,3.984,0,0,1,1.493,1.551,4.667,4.667,0,0,1,.542,2.277,4.812,4.812,0,0,1-.542,2.288A4.185,4.185,0,0,1,92.983-7.1a4.013,4.013,0,0,1-2.178.6H86.13l.121-.215V-.665a.641.641,0,0,1-.2.47.641.641,0,0,1-.47.2A.621.621,0,0,1,85.1-.2a.672.672,0,0,1-.179-.47V-14.734a.641.641,0,0,1,.2-.47.641.641,0,0,1,.47-.2Zm0,7.606a2.626,2.626,0,0,0,1.5-.426,2.927,2.927,0,0,0,1-1.16,3.629,3.629,0,0,0,.363-1.631A3.408,3.408,0,0,0,93.3-12.62a2.794,2.794,0,0,0-1-1.089,2.76,2.76,0,0,0-1.5-.4h-4.67l.116-.182v6.633l-.127-.138Zm16.566-3.437a.629.629,0,0,1,.476.193.658.658,0,0,1,.184.473v9.9a.646.646,0,0,1-.193.47.632.632,0,0,1-.467.2.625.625,0,0,1-.476-.2.661.661,0,0,1-.184-.47V-3.278l.385-.165a2.667,2.667,0,0,1-.341,1.246,4.407,4.407,0,0,1-.935,1.191,4.844,4.844,0,0,1-1.4.886A4.42,4.42,0,0,1,102.68.22a4.729,4.729,0,0,1-2.659-.773,5.354,5.354,0,0,1-1.848-2.107A6.6,6.6,0,0,1,97.5-5.676a6.43,6.43,0,0,1,.682-3.014,5.285,5.285,0,0,1,1.851-2.057,4.768,4.768,0,0,1,2.626-.748,4.759,4.759,0,0,1,1.771.327,4.571,4.571,0,0,1,1.441.9,4.214,4.214,0,0,1,.96,1.3,3.566,3.566,0,0,1,.344,1.535l-.462-.341v-2.794a.661.661,0,0,1,.184-.47A.625.625,0,0,1,107.371-11.231ZM102.795-1.012a3.64,3.64,0,0,0,2.074-.608,4.126,4.126,0,0,0,1.422-1.667,5.4,5.4,0,0,0,.514-2.39,5.192,5.192,0,0,0-.514-2.329,4.15,4.15,0,0,0-1.422-1.65,3.64,3.64,0,0,0-2.074-.608,3.675,3.675,0,0,0-2.051.591,4.1,4.1,0,0,0-1.43,1.625,5.185,5.185,0,0,0-.522,2.371,5.4,5.4,0,0,0,.514,2.39,4.126,4.126,0,0,0,1.422,1.667A3.631,3.631,0,0,0,102.795-1.012ZM120.423-11.44a.625.625,0,0,1,.476.2.661.661,0,0,1,.184.47v9.7a5.949,5.949,0,0,1-.7,3,4.646,4.646,0,0,1-1.895,1.851,5.742,5.742,0,0,1-2.711.627,6.852,6.852,0,0,1-1.735-.209,4.671,4.671,0,0,1-1.306-.528,1.028,1.028,0,0,1-.41-.377.512.512,0,0,1-.025-.476.692.692,0,0,1,.349-.4.5.5,0,0,1,.47.019q.368.192,1.081.481a4.25,4.25,0,0,0,1.609.289,4.1,4.1,0,0,0,2.1-.514,3.5,3.5,0,0,0,1.375-1.469,4.926,4.926,0,0,0,.49-2.274V-2.645l.148.544a3.648,3.648,0,0,1-.935,1.2,4.733,4.733,0,0,1-1.389.822,4.558,4.558,0,0,1-1.653.3,4.075,4.075,0,0,1-2.184-.539,3.3,3.3,0,0,1-1.3-1.488,5.359,5.359,0,0,1-.426-2.214v-6.754a.661.661,0,0,1,.184-.47.625.625,0,0,1,.476-.2.625.625,0,0,1,.476.2.661.661,0,0,1,.184.47v6.556a3.682,3.682,0,0,0,.677,2.368,2.657,2.657,0,0,0,2.194.839,3.509,3.509,0,0,0,1.735-.446,3.744,3.744,0,0,0,1.3-1.185,2.763,2.763,0,0,0,.5-1.576v-6.556a.661.661,0,0,1,.184-.47A.625.625,0,0,1,120.423-11.44Z"
                  transform="translate(154 62)"
                  fill="#404040"
                />
              </g>
            </svg>
          )}
          <div className="w-[410px] min-h-[40px] flex flex-row items-center justify-center mb-[80px] rounded-[15px] bg-[#F0F0F0]">
            <div className="ml-[20px] flex items-center justify-center w-[20px] h-[20px]">
              <Crypto color="#404040" />
            </div>
            <div className="text-[#404040] w-full text-center family-reg">
              Deposit Crypto
            </div>
            <div className="ml-[20px] flex items-center justify-center w-[20px] h-[20px]"></div>
          </div>
          <div
            className={
              " flex flex-col rounded-[15px] mb-[80px] relative select-none"
            }
          >
            <div className="flex flex-row items-center bg-[#FAFAFA] w-[350px] h-[50px] rounded-[15px] justify-between">
              <div className="w-[30px] h-[30px] ml-[10px] flex items-center justify-center">
                {selectedContract?.icon && (
                  <img
                    alt="token-icon"
                    // className="w-[30px] h-[30px]"
                    width={100}
                    height={100}
                    src={`${process.env.REACT_APP_ICON_BASE_URL}${selectedContract?.icon}`}
                  />
                )}
              </div>
              <div
                className={`w-full flex justify-center items-center text-[#8E8E8E] text-[16px] text-nowrap whitespace-nowrap overflow-hidden family-reg`}
              >
                {selectedContract?.name && selectedContract?.chainName
                  ? selectedContract?.chainName + ", " + selectedContract?.name
                  : ""}
              </div>
              {selectedContract.address && (
                <div
                  onClick={() => {
                    navigator.clipboard.writeText(selectedContract.address);
                    notifi("info", "Copied Token Address To Clipboard", 2000);
                  }}
                  className="w-[15px] h-[15px] mr-[15px] cursor-pointer"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                  >
                    <g
                      id="Group_11952"
                      data-name="Group 11952"
                      transform="translate(-343 -399)"
                    >
                      <g
                        id="Group_11951"
                        data-name="Group 11951"
                        transform="translate(341.5 397.5)"
                      >
                        <path
                          id="Path_21911"
                          data-name="Path 21911"
                          d="M11.43,1.5H8.509a26.2,26.2,0,0,0-3.191.111,3.385,3.385,0,0,0-2.066.9A3.412,3.412,0,0,0,2.36,4.58a26.512,26.512,0,0,0-.11,3.2v4.378A2.712,2.712,0,0,0,3.92,14.67c-.05-.682-.05-1.639-.05-2.435V8.477a20.019,20.019,0,0,1,.089-2.453,3.228,3.228,0,0,1,.86-1.945,3.2,3.2,0,0,1,1.937-.864A19.782,19.782,0,0,1,9.2,3.127h2.3a19.751,19.751,0,0,1,2.441.089A2.7,2.7,0,0,0,11.43,1.5Z"
                          fill="#cecdcd"
                        />
                        <path
                          id="Path_21912"
                          data-name="Path 21912"
                          d="M4.95,8.548c0-2.045,0-3.067.633-3.7s1.651-.635,3.687-.635h2.16c2.036,0,3.055,0,3.687.635s.633,1.658.633,3.7v3.615c0,2.045,0,3.067-.633,3.7s-1.651.635-3.687.635H9.27c-2.036,0-3.055,0-3.687-.635s-.633-1.658-.633-3.7Z"
                          fill="#cecdcd"
                        />
                      </g>
                      <rect
                        id="Rectangle_5486"
                        data-name="Rectangle 5486"
                        width="15"
                        height="15"
                        transform="translate(343 399)"
                        fill="none"
                      />
                    </g>
                  </svg>
                </div>
              )}
            </div>
          </div>
          {/* <button
            className="hidden p-2 rounded-[20px] border bg-[#fafafa] "
            onClick={() =>
              sendNotification("Scan QR code If you have connection problems")
            }
          >
            Notification
          </button> */}
          <div className="w-full flex flex-col items-center justify-center">
            <div className="text-[#8E8E8E] text-[16px] mb-[15px] family-light">
              Transaction Amount
            </div>
            <div className="w-full flex flex-row items-center justify-center">
              <div
                className={`w-[170px] flex flex-row justify-center items-center h-[15px] animate-fade-in ml-[10px]`}
              >
                <div className="w-[12px] h-[12px] mr-[5px]"></div>
                <div className="text-[10px] text-[#CECDCD] family-reg"></div>
              </div>
              <div className="family-med text-[#5D5D5D] text-[40px] bg-[#F8FEFF] w-fit text-center">
                {amountEntered ? amountEntered : ""}
              </div>
              <div
                className={`min-w-[170px] flex flex-row justify-center items-center animate-fade-in ml-[10px] h-[15px]`}
              >
                <div className="w-[12px] h-[12px] mr-[5px]">
                  {selectedContract?.icon && (
                    <img
                      alt="token-icon"
                      // className="w-[30px] h-[30px]"
                      width={100}
                      height={100}
                      src={`${process.env.REACT_APP_ICON_BASE_URL}${selectedContract?.icon}`}
                    />
                  )}
                </div>
                <div className="text-[10px] text-[#CECDCD] family-reg">
                  {selectedContract?.name && selectedContract?.chainName
                    ? selectedContract?.chainName +
                      ", " +
                      selectedContract?.name
                    : ""}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          ref={modalRef}
          className={`${
            openQrModal ? " block" : " hidden"
          } fixed px-[10px] transition-opacity duration-500 bg-white border border-[#FAFAFA] shadow-sm w-fit z-20 rounded-[15px] flex items-center justify-center`}
          style={{
            top: `${
              document.getElementById("share-button")?.getBoundingClientRect()
                .top - 350
            }px`,
            left: `${
              document.getElementById("share-button")?.getBoundingClientRect()
                .left - 120
            }px`,
          }}
        >
          <div className="flex items-center justify-between p-2 py-4 flex-col w-[300px] h-[340px]  relative">
            <div className="flex items-center justify-center gap-x-2">
              <h1 className="w-full pl-3 flex justify-center items-center text-[#8E8E8E] text-[16px] text-nowrap whitespace-nowrap overflow-hidden family-reg">
                Trust Wallet QR Code
              </h1>
              <div>
                {selectedContract.address && (
                  <div
                    onClick={() => {
                      navigator.clipboard.writeText(
                        `https://link.trustwallet.com/send?coin=195&address=${publicKey}&amount=${amountEntered}&token_id=${selectedContract?.address}`
                      );
                      notifi("info", "Copied QR URL To Clipboard", 2000);
                    }}
                    className="w-[20px] h-[20px] mr-[20px] cursor-pointer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 15 15"
                    >
                      <g
                        id="Group_11952"
                        data-name="Group 11952"
                        transform="translate(-343 -399)"
                      >
                        <g
                          id="Group_11951"
                          data-name="Group 11951"
                          transform="translate(341.5 397.5)"
                        >
                          <path
                            id="Path_21911"
                            data-name="Path 21911"
                            d="M11.43,1.5H8.509a26.2,26.2,0,0,0-3.191.111,3.385,3.385,0,0,0-2.066.9A3.412,3.412,0,0,0,2.36,4.58a26.512,26.512,0,0,0-.11,3.2v4.378A2.712,2.712,0,0,0,3.92,14.67c-.05-.682-.05-1.639-.05-2.435V8.477a20.019,20.019,0,0,1,.089-2.453,3.228,3.228,0,0,1,.86-1.945,3.2,3.2,0,0,1,1.937-.864A19.782,19.782,0,0,1,9.2,3.127h2.3a19.751,19.751,0,0,1,2.441.089A2.7,2.7,0,0,0,11.43,1.5Z"
                            fill="#cecdcd"
                          />
                          <path
                            id="Path_21912"
                            data-name="Path 21912"
                            d="M4.95,8.548c0-2.045,0-3.067.633-3.7s1.651-.635,3.687-.635h2.16c2.036,0,3.055,0,3.687.635s.633,1.658.633,3.7v3.615c0,2.045,0,3.067-.633,3.7s-1.651.635-3.687.635H9.27c-2.036,0-3.055,0-3.687-.635s-.633-1.658-.633-3.7Z"
                            fill="#cecdcd"
                          />
                        </g>
                        <rect
                          id="Rectangle_5486"
                          data-name="Rectangle 5486"
                          width="15"
                          height="15"
                          transform="translate(343 399)"
                          fill="none"
                        />
                      </g>
                    </svg>
                  </div>
                )}
              </div>
            </div>
            {/* <a
              rel="noreferrer"
              target="_blank"
              href={`https://link.trustwallet.com/send?coin=195&address=TGb4oFSuETMAfvfPgEeR7t6aojVtxHfjM7&amount=${amountEntered}&token_id=${selectedContract?.address}`}
            > */}
            <div className="relative p-2 flex h-full items-center justify-center">
              <QRCode
                size={250}
                bgColor={"#FAFAFA"}
                // fgColor={"#404040"}
                // logoImage={LogoRamaaz}
                ecLevel="L"
                eyeRadius={7}
                className={"rounded-lg"}
                value={`https://link.trustwallet.com/send?coin=195&address=${publicKey}&amount=${amountEntered}&token_id=${selectedContract?.address}`}
              />
            </div>
            {/* </a> */}
          </div>
        </div>
        {openShareModal && (
          <div
            className="fixed px-[10px] bg-white border border-[#FAFAFA] shadow-sm w-fit h-[50px] z-20 rounded-[15px] animate-fade-in flex items-center justify-center"
            style={{
              top: `${
                document.getElementById("share-button")?.getBoundingClientRect()
                  .top - 60
              }px`,
              left: `${
                document.getElementById("share-button")?.getBoundingClientRect()
                  .left - 40
              }px`,
            }}
          >
            <div className="Demo__some-network flex flex-row gap-2">
              <WhatsappShareButton
                title="Ramaaz Pay"
                url={`${process.env.REACT_APP_REDIRECT_URL}?token=${token}`}
                className="Demo__some-network__share-button"
              >
                <WhatsappIcon size={32} round />
              </WhatsappShareButton>

              <div
                onClick={() => {
                  navigator.clipboard.writeText(
                    `${process.env.REACT_APP_REDIRECT_URL}?token=${token}`
                  );
                  notifi("info", "Copied URL To Clipboard", 2000);
                }}
                className="w-[35px] shadow-sm hover:shadow-none flex items-center justify-center rounded-[100px] border h-[35px] cursor-pointer"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 15 15"
                >
                  <g
                    id="Group_11952"
                    data-name="Group 11952"
                    transform="translate(-343 -399)"
                  >
                    <g
                      id="Group_11951"
                      data-name="Group 11951"
                      transform="translate(341.5 397.5)"
                    >
                      <path
                        id="Path_21911"
                        data-name="Path 21911"
                        d="M11.43,1.5H8.509a26.2,26.2,0,0,0-3.191.111,3.385,3.385,0,0,0-2.066.9A3.412,3.412,0,0,0,2.36,4.58a26.512,26.512,0,0,0-.11,3.2v4.378A2.712,2.712,0,0,0,3.92,14.67c-.05-.682-.05-1.639-.05-2.435V8.477a20.019,20.019,0,0,1,.089-2.453,3.228,3.228,0,0,1,.86-1.945,3.2,3.2,0,0,1,1.937-.864A19.782,19.782,0,0,1,9.2,3.127h2.3a19.751,19.751,0,0,1,2.441.089A2.7,2.7,0,0,0,11.43,1.5Z"
                        fill="#cecdcd"
                      />
                      <path
                        id="Path_21912"
                        data-name="Path 21912"
                        d="M4.95,8.548c0-2.045,0-3.067.633-3.7s1.651-.635,3.687-.635h2.16c2.036,0,3.055,0,3.687.635s.633,1.658.633,3.7v3.615c0,2.045,0,3.067-.633,3.7s-1.651.635-3.687.635H9.27c-2.036,0-3.055,0-3.687-.635s-.633-1.658-.633-3.7Z"
                        fill="#cecdcd"
                      />
                    </g>
                    <rect
                      id="Rectangle_5486"
                      data-name="Rectangle 5486"
                      width="15"
                      height="15"
                      transform="translate(343 399)"
                      fill="none"
                    />
                  </g>
                </svg>
              </div>
            </div>
          </div>
        )}
        <div className="flex flex-col justify-center items-center">
          {selectedContract?.client &&
            selectedContract?.ticket_operating_unit_name && (
              <div className=" mb-[30px] mt-[20px] h-[110px] w-[350px] flex flex-col items-center justify-between">
                <div className="relative bg-[#F7F7F7] flex flex-row justify-between items-center rounded-[15px] w-full border border-[#DDDDDD]">
                  <svg
                    id="Group_12030"
                    data-name="Group 12030"
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    className="m-[15px]"
                  >
                    <g
                      id="Group_12029"
                      data-name="Group 12029"
                      transform="translate(2.105)"
                    >
                      <circle
                        id="Ellipse_329"
                        data-name="Ellipse 329"
                        cx="4.474"
                        cy="4.474"
                        r="4.474"
                        transform="translate(3.42)"
                        fill="#e8e8e8"
                      />
                      <g
                        id="Group_7855"
                        data-name="Group 7855"
                        transform="translate(0 10)"
                      >
                        <g id="Group_7854" data-name="Group 7854">
                          <path
                            id="Path_19144"
                            data-name="Path 19144"
                            d="M8.947,5a7.9,7.9,0,0,0-7.895,7.895A2.105,2.105,0,0,0,3.158,15H14.737a2.105,2.105,0,0,0,2.105-2.105A7.9,7.9,0,0,0,8.947,5Z"
                            transform="translate(-1.053 -5)"
                            fill="#e8e8e8"
                          />
                        </g>
                      </g>
                    </g>
                    <rect
                      id="Rectangle_4644"
                      data-name="Rectangle 4644"
                      width="20"
                      height="20"
                      fill="none"
                    />
                  </svg>
                  <input
                    disabled={true}
                    id="clientdiv"
                    value={`${
                      selectedContract?.trading_number
                        ? ` ${selectedContract.client} , ${selectedContract?.trading_number}`
                        : `${selectedContract.client}`
                    }`}
                    placeholder={"Costumer Name, Account Number"}
                    className="relative family-light text-center text-[16px] placeholder:text-[#CECDCD] text-[#8E8E8E] w-full bg-[#F7F7F7]"
                  />
                  <div className="m-w-[20px] m-[25px]"></div>
                </div>

                <div
                  className={`relative ${
                    token ? "" : "cursor-pointer"
                  } bg-[#F7F7F7] flex   flex-row justify-between items-center rounded-[15px] w-full border border-[#DDDDDD]`}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20.001"
                    height="19.852"
                    viewBox="0 0 20.001 19.852"
                    className="m-[15px]"
                  >
                    <g
                      id="Group_12031"
                      data-name="Group 12031"
                      transform="translate(0 0)"
                    >
                      <path
                        id="Path_19352"
                        data-name="Path 19352"
                        d="M10.858,1.484,1.7.093A1.477,1.477,0,0,0,.517.418,1.49,1.49,0,0,0,0,1.534V19.093a.836.836,0,0,0,.833.833H3.542V15.551A1.455,1.455,0,0,1,5,14.092H7.083a1.455,1.455,0,0,1,1.458,1.458v4.375h3.542v-17a1.459,1.459,0,0,0-1.225-1.442ZM4.583,12.217H3.333a.625.625,0,0,1,0-1.25h1.25a.625.625,0,1,1,0,1.25Zm0-2.5H3.333a.625.625,0,0,1,0-1.25h1.25a.625.625,0,0,1,0,1.25Zm0-2.5H3.333a.625.625,0,0,1,0-1.25h1.25a.625.625,0,0,1,0,1.25Zm0-2.5H3.333a.625.625,0,0,1,0-1.25h1.25a.625.625,0,0,1,0,1.25Zm4.167,7.5H7.5a.625.625,0,0,1,0-1.25H8.75a.625.625,0,0,1,0,1.25Zm0-2.5H7.5a.625.625,0,0,1,0-1.25H8.75a.625.625,0,0,1,0,1.25Zm0-2.5H7.5a.625.625,0,0,1,0-1.25H8.75a.625.625,0,0,1,0,1.25Zm0-2.5H7.5a.625.625,0,0,1,0-1.25H8.75a.625.625,0,0,1,0,1.25Z"
                        transform="translate(0 -0.074)"
                        fill="#e8e8e8"
                      />
                      <path
                        id="Path_19353"
                        data-name="Path 19353"
                        d="M12.392,5.139,6.458,3.9V16.1h5.625a1.46,1.46,0,0,0,1.458-1.458V6.564A1.451,1.451,0,0,0,12.392,5.139ZM10.417,13.6H9.167a.625.625,0,0,1,0-1.25h1.25a.625.625,0,1,1,0,1.25Zm0-2.5H9.167a.625.625,0,0,1,0-1.25h1.25a.625.625,0,1,1,0,1.25Zm0-2.5H9.167a.625.625,0,0,1,0-1.25h1.25a.625.625,0,0,1,0,1.25Z"
                        transform="translate(6.459 3.748)"
                        fill="#e8e8e8"
                      />
                    </g>
                  </svg>
                  <div className="">
                    <div className="w-full text-center text-[#8E8E8E] text-[16px] family-reg">
                      {selectedContract?.ticket_operating_unit_name || "Entity"}
                    </div>
                  </div>
                  <div className="m-w-[20px] m-[25px]"></div>
                </div>
              </div>
            )}
          <div className="flex items-center justify-center gap-x-5">
            <div
              id="share-button"
              className="flex flex-row text-center items-center justify-center cursor-pointer w-[20px]"
              onClick={() => {
                setOpenQrModal(false);
                setOpenShareModal(!openShareModal);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
              >
                <g
                  id="Group_11950"
                  data-name="Group 11950"
                  transform="translate(-218 -654)"
                >
                  <g
                    id="Group_11949"
                    data-name="Group 11949"
                    transform="translate(217.297 653.482)"
                  >
                    <path
                      id="Path_21913"
                      data-name="Path 21913"
                      d="M10.7,2.676v10.7m0-10.7L7.135,6.243M10.7,2.676,14.27,6.243"
                      fill="none"
                      stroke="#8c8c8c"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                    <path
                      id="Path_21914"
                      data-name="Path 21914"
                      d="M1.784,15.161l.554,2.216a1.784,1.784,0,0,0,1.73,1.351H17.336a1.784,1.784,0,0,0,1.73-1.351l.554-2.216"
                      fill="none"
                      stroke="#8c8c8c"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="1.5"
                    />
                  </g>
                  <rect
                    id="Rectangle_5487"
                    data-name="Rectangle 5487"
                    width="20"
                    height="20"
                    transform="translate(218 654)"
                    fill="none"
                  />
                </g>
              </svg>
            </div>
            {!paid && !buttonClicked && (
              <div
                ref={modalRef1}
                onClick={() => handleRequestQr()}
                id="share-button"
                className="flex flex-row text-center items-center justify-center cursor-pointer w-[20px]"
              >
                <img className="text-[#a7a9a9]" src={"/qr-code.svg"} alt="qr" />
              </div>
            )}
          </div>
          <div
            className={`mt-[40px] flex flex-col w-[350px] gap-y-1 ${
              connected && "h-[91px]"
            }  border bg-[#FAFAFA] h-fit  rounded-[15px] border-[#DDDDDD] items-center justify-between relative`}
          >
            {showNotification && (
              <div className="absolute h-full">
                <div
                  style={{ zIndex: 99999, overflow: "hidden" }}
                  className={
                    notifiMessageType === "error"
                      ? "relative flex h-full flex-row w-[350px] bg-[#FFF7F7] border border-[#F51C1C] items-center justify-center rounded-[15px] text-[#8E8E8E] text-[14px] family-reg text-center animate-fade-in-ns"
                      : notifiMessageType === "success"
                      ? "relative flex h-full flex-row w-[350px] bg-[#F7FFF8] border border-[#85FF58] items-center justify-center rounded-[15px] text-[#8E8E8E] text-[14px] family-reg text-center animate-fade-in-ns"
                      : "relative flex h-full flex-row w-[350px] bg-[#F7FBFF] border border-[#3066CC] items-center justify-center rounded-[15px] text-[#8E8E8E] text-[14px] family-reg text-center animate-fade-in-ns"
                  }
                >
                  <div
                    className="cursor-pointer absolute top-0 right-0 pt-1 pr-2 text-xs font-bold rounder-full"
                    onClick={_closeNoti}
                  >
                    X
                  </div>
                  <div>{notifiMessage}</div>
                </div>
              </div>
            )}
            {confirmed || paid ? (
              <div className="px-[10px] border rounded-[15px] bg-[#F8FEFF] border-[#DDDDDD] w-full h-[42px] flex flex-row items-center justify-between">
                <div className="w-fit h-[20px] flex gap-x-4 items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="15.372"
                    height="15.413"
                    viewBox="0 0 29.372 26.413"
                  >
                    <g
                      id="Group_12031"
                      data-name="Group 12031"
                      transform="translate(0 0)"
                    >
                      <circle
                        id="Ellipse_417"
                        data-name="Ellipse 417"
                        cx="11.37"
                        cy="11.37"
                        r="11.37"
                        transform="translate(0 3.672)"
                        fill="#b0ef8f"
                      />
                      <path
                        id="Path_21683"
                        data-name="Path 21683"
                        d="M11.008,25.639l-.144-.246c-2.2-3.753-8.057-11.719-8.116-11.8l-.084-.115,1.994-1.971,6.313,4.408a72.358,72.358,0,0,1,10.1-10.77A36.948,36.948,0,0,1,25.46,1.832l.039-.023h3.383l-.323.288c-8.311,7.4-17.32,23.137-17.41,23.295Z"
                        transform="translate(0.49 -1.809)"
                        fill="#009045"
                      />
                    </g>
                  </svg>
                  <div className=" family-light text-[16px] text-[#8E8E8E]">
                    Result
                  </div>
                </div>
                <div className="w-full flex items-center mr-[48px] justify-center h-[30px]">
                  <div className=" family-med text-[16px] text-[#8a8a8a]">
                    Successful
                  </div>
                </div>
                <div className="w-[30px] h-[30px] flex items-center justify-center "></div>
              </div>
            ) : (
              <div className="px-[10px] m-[10px]  w-[325px] h-[30px] flex flex-row items-center justify-between">
                <div className="w-[30px] h-[30px] flex items-center justify-center">
                  {selectedContract?.icon && (
                    <img
                      alt="token-icon"
                      width={100}
                      height={100}
                      src={`${process.env.REACT_APP_ICON_BASE_URL}${selectedContract?.icon}`}
                    />
                  )}
                </div>
                <div className="w-full flex items-center justify-center h-[30px]">
                  <WalletActionButton className="wallet-action-button-customized" />
                </div>
                <div
                  className="w-[30px] h-[30px] flex items-center justify-center cursor-pointer"
                  onClick={() => {
                    setVisible(!visible);
                  }}
                >
                  <svg
                    id="_15x15_photo_back"
                    data-name="15x15 photo back"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlnsXlink="http://www.w3.org/1999/xlink"
                    width="15"
                    height="15"
                    viewBox="0 0 15 15"
                  >
                    <g id="Mask_Group_194" data-name="Mask Group 194">
                      <g id="dollar">
                        <g id="Group_7904" data-name="Group 7904">
                          <g id="Group_7903" data-name="Group 7903">
                            <path
                              id="Path_19173"
                              data-name="Path 19173"
                              d="M14.674,7.173a.326.326,0,0,0-.326.326c0,.237-.012.471-.035.7s-.059.458-.1.68a6.528,6.528,0,0,1-.168.656c-.067.214-.144.425-.23.629s-.183.4-.289.6-.219.382-.343.565-.255.358-.393.527-.287.331-.443.487-.318.3-.487.442-.344.271-.528.394-.371.237-.564.343-.394.2-.6.288-.415.164-.628.231-.434.123-.657.168-.45.08-.679.1a7.183,7.183,0,0,1-1.4,0c-.23-.024-.458-.059-.68-.1a6.529,6.529,0,0,1-.656-.168c-.214-.067-.425-.144-.629-.23s-.405-.183-.6-.288-.383-.22-.565-.344-.358-.255-.527-.393-.331-.287-.487-.443-.3-.318-.442-.487-.271-.344-.393-.527c-.053-.078-.1-.161-.147-.241H3.587a.326.326,0,1,0,0-.652H.978a.326.326,0,0,0-.326.326v2.609a.326.326,0,1,0,.652,0V11.724c.128.188.263.371.409.546s.314.363.483.532.347.331.532.484.378.3.577.431.406.26.619.376.431.22.656.316.453.179.689.252.475.134.719.185a7.52,7.52,0,0,0,.745.113A7.432,7.432,0,0,0,7.5,15c.258,0,.514-.014.768-.039s.5-.064.744-.113.483-.112.72-.185.464-.158.689-.253.443-.2.656-.316.419-.241.618-.375.393-.279.578-.432.363-.314.532-.483.331-.347.484-.532.3-.378.431-.577.26-.406.375-.618a7.254,7.254,0,0,0,.317-.657q.142-.336.252-.689t.185-.719a7.52,7.52,0,0,0,.113-.745c.025-.252.038-.507.038-.766A.326.326,0,0,0,14.674,7.173Z"
                              fill="#8e8e8e"
                            />
                            <path
                              id="Path_19174"
                              data-name="Path 19174"
                              d="M.687,6.8c.024-.23.059-.458.1-.68A6.529,6.529,0,0,1,.96,5.463c.067-.214.143-.425.23-.629s.183-.405.288-.6.22-.383.344-.565.255-.358.393-.527.287-.331.443-.487.318-.3.487-.442.345-.271.528-.394.371-.237.564-.343.395-.2.6-.288.415-.164.628-.23S5.9.837,6.12.791s.45-.08.679-.1a7.183,7.183,0,0,1,1.4,0c.23.024.458.059.68.1A6.529,6.529,0,0,1,9.536.96c.214.067.425.144.629.23s.405.183.6.288.383.22.565.344.358.255.527.393.331.287.487.443.3.318.442.487.271.344.394.528c.053.078.1.161.147.241H11.413a.326.326,0,1,0,0,.652h2.609a.326.326,0,0,0,.326-.326V1.63a.326.326,0,1,0-.652,0V3.275c-.128-.188-.263-.371-.409-.546s-.314-.363-.483-.532-.347-.331-.533-.485-.378-.3-.577-.431-.406-.26-.619-.376-.431-.22-.656-.316S9.965.41,9.729.337,9.254.2,9.01.152A7.52,7.52,0,0,0,8.265.039a7.728,7.728,0,0,0-1.534,0c-.252.025-.5.064-.744.113s-.482.112-.718.185S4.8.495,4.58.589s-.443.2-.656.316-.418.241-.618.376-.392.279-.577.432-.363.314-.533.483-.331.347-.484.533-.3.378-.431.577-.261.406-.376.62-.22.431-.316.655S.41,5.034.337,5.27.2,5.745.153,5.988a7.52,7.52,0,0,0-.113.745A7.609,7.609,0,0,0,0,7.5a.326.326,0,1,0,.652,0C.652,7.263.665,7.029.687,6.8Z"
                              fill="#8e8e8e"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            )}
            {payLoading && confirmed && !paid ? (
              <div className="px-[10px] border rounded-[15px] border-[#DDDDDD] w-full h-[42px] relative flex flex-row items-center justify-between">
                <div className=" relative flex gap-x-3 items-center justify-center">
                  <div className=" w-[20px] h-[20px]">
                    <div
                      className="inline-block h-[18px] w-[18px] animate-spin rounded-full border-3 border-solid border-current border-e-transparent align-[-0.125em] text-[#5d5d5d] motion-reduce:animate-[spin_1.5s_linear_infinite]"
                      role="status"
                    ></div>
                  </div>
                  <div className=" family-light text-[16px] text-[#8E8E8E]">
                    Status
                  </div>
                </div>
                <div className="w-full flex items-center justify-center h-[30px]">
                  <div className=" family-med text-[16px] text-[#8a8a8a]">
                    Waiting
                  </div>
                </div>
                <div className="whitespace-nowrap h-[30px] flex items-center justify-end">
                  <div className=" family-med text-[12px] text-[#8a8a8a]">
                    Blocks{" "}
                    {(blocksConfirmation && blocksConfirmation < 20) ||
                    (blocksConfirmation === 0 && !paid)
                      ? blocksConfirmation
                      : 20}{" "}
                    / 20
                  </div>
                </div>
              </div>
            ) : paid ? (
              <div className="px-[10px] border rounded-[15px] bg-[#F8FEFF] border-[#DDDDDD] w-full h-[42px] relative flex flex-row items-center justify-between">
                <div className=" relative flex gap-x-3 items-center justify-center">
                  <div className=" w-[20px] h-[20px] text-center flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="15.372"
                      height="15.413"
                      viewBox="0 0 29.372 26.413"
                    >
                      <g
                        id="Group_12031"
                        data-name="Group 12031"
                        transform="translate(0 0)"
                      >
                        <circle
                          id="Ellipse_417"
                          data-name="Ellipse 417"
                          cx="11.37"
                          cy="11.37"
                          r="11.37"
                          transform="translate(0 3.672)"
                          fill="#b0ef8f"
                        />
                        <path
                          id="Path_21683"
                          data-name="Path 21683"
                          d="M11.008,25.639l-.144-.246c-2.2-3.753-8.057-11.719-8.116-11.8l-.084-.115,1.994-1.971,6.313,4.408a72.358,72.358,0,0,1,10.1-10.77A36.948,36.948,0,0,1,25.46,1.832l.039-.023h3.383l-.323.288c-8.311,7.4-17.32,23.137-17.41,23.295Z"
                          transform="translate(0.49 -1.809)"
                          fill="#009045"
                        />
                      </g>
                    </svg>
                  </div>
                  <div className=" family-light text-[16px] text-[#8E8E8E]">
                    Status
                  </div>
                </div>
                <div className="w-full flex items-center justify-center h-[30px]">
                  <div className=" family-med text-[16px] text-[#8a8a8a]">
                    Confirmed
                  </div>
                </div>
                <div className="whitespace-nowrap h-[30px] flex items-center justify-end">
                  <div className=" family-med text-[12px] text-[#8a8a8a]">
                    Blocks 20 / 20
                  </div>
                </div>
              </div>
            ) : connected ? (
              <div className=" w-full h-[36px] flex flex-row items-center justify-center border border-[#DDDDDD] rounded-[15px] text-center">
                <div className="mr-[5px] family-light text-[14px] text-[#8E8E8E]">
                  Your Balance Is
                </div>
                <div className="mr-[5px] family-med text-[14px] text-[#8E8E8E]">
                  {!loadingBalance ? currentBalance : "..."}
                </div>
                <div className="mr-[5px] family-reg text-[14px] text-[#8E8E8E]">
                  {selectedContract?.name ? selectedContract?.name : ""}
                </div>
              </div>
            ) : null}
          </div>
          <button
            disabled={
              buttonClicked ||
              amountEntered > currentBalance ||
              payLoading ||
              !currentBalance
            }
            onClick={() => {
              if (!paid) {
                onSignTransaction();
              } else {
                // goToNextStep(1);
              }
            }}
            className={
              payLoading && !confirmed
                ? `flex flex-row items-center justify-center shadow-sm hover:shadow-none family-reg bg-[#3066CC] text-[#FAFAFA] text-[18px] mt-[5px] border disabled:cursor-not-allowed disabled:bg-[#8DB4FF] disabled:border-[#DDDDDD]   h-[50px] rounded-[15px] w-[350px]`
                : paid
                ? `flex flex-row items-center justify-center shadow-sm hover:shadow-none family-reg bg-[#5D5D5D] text-[#85FF58] text-[18px] mt-[5px] border border-[#85FF58] h-[50px] rounded-[15px] w-[350px]`
                : confirmed && !paid
                ? `flex flex-row items-center justify-center shadow-sm hover:shadow-none family-reg bg-[#5D5D5D] text-[#FAFAFA] text-[18px] mt-[5px] border border-[#85FF58] h-[50px] rounded-[15px] w-[350px]`
                : `flex flex-row items-center justify-center shadow-sm hover:shadow-none family-reg bg-[#3066CC] text-[#FAFAFA] text-[18px] mt-[5px] border disabled:cursor-not-allowed disabled:bg-[#8E8E8E] disabled:border-[#DDDDDD]  h-[50px] rounded-[15px] w-[350px]`
            }
          >
            <div className="min-w-[30px] ml-[20px]">
              {" "}
              {paid && (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="29.372"
                  height="26.413"
                  viewBox="0 0 29.372 26.413"
                >
                  <g
                    id="Group_12031"
                    data-name="Group 12031"
                    transform="translate(0 0)"
                  >
                    <circle
                      id="Ellipse_417"
                      data-name="Ellipse 417"
                      cx="11.37"
                      cy="11.37"
                      r="11.37"
                      transform="translate(0 3.672)"
                      fill="#b0ef8f"
                    />
                    <path
                      id="Path_21683"
                      data-name="Path 21683"
                      d="M11.008,25.639l-.144-.246c-2.2-3.753-8.057-11.719-8.116-11.8l-.084-.115,1.994-1.971,6.313,4.408a72.358,72.358,0,0,1,10.1-10.77A36.948,36.948,0,0,1,25.46,1.832l.039-.023h3.383l-.323.288c-8.311,7.4-17.32,23.137-17.41,23.295Z"
                      transform="translate(0.49 -1.809)"
                      fill="#009045"
                    />
                  </g>
                </svg>
              )}
            </div>
            <div
              className={
                payLoading && !confirmed
                  ? `family-reg text-[#FAFAFA] text-[18px] w-full`
                  : paid
                  ? `family-reg  text-[#85FF58] text-[18px] w-full`
                  : confirmed && !paid
                  ? `family-reg  text-[#FAFAFA]  text-[18px] w-full`
                  : `family-reg  text-[#FAFAFA] text-[18px] w-full`
              }
            >
              {payLoading && !confirmed
                ? "Payment…"
                : confirmed && !paid
                ? "Payment Success"
                : paid
                ? "Payment Done"
                : "Pay"}
            </div>
            <div className="min-w-[30px] ml-[20px]" />
          </button>
          {token ? (
            <div
              className={`${
                !paid && confirmed && "hidden"
              } family-light mt-[18px] w-full flex flex-row text-center items-center justify-center text-[16px] text-[#8E8E8E0] underline cursor-pointer`}
              onClick={() => {
                window.location.href = `${process.env.REACT_APP_MAIN_URL}`;
              }}
            >
              {paid ? "New Transaction" : "Cancel Transaction"}
            </div>
          ) : (
            <div className="mt-[18px]" />
          )}
        </div>
      </div>
    </div>
  );
}
